import { render, staticRenderFns } from "./SolicitudForm.vue?vue&type=template&id=a57c7070"
import script from "./SolicitudForm.vue?vue&type=script&lang=js"
export * from "./SolicitudForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports